<template>
  <div>
    <common-dialog
      ref="dialog"
      width="800px"
      edit-title
      title="周末留宿人数一览表"
      id-key="StayRegId"
      :data="data"
      form-label-width="70px"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      @details-opened="onDetailsOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="查询日期">
              <el-date-picker 
              v-model="searchDate" 
              type="date"
              value-format="yyyy/MM/dd"
              placeholder="请选择日期"
              :clearable="false"
              style="width:160px;margin-right:10px;"
              ></el-date-picker>
              <el-button type="primary" @click="getData">查 询</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="24" class="title">
            {{dateCN(data.Start)}}
            <span v-if="data.End"> - </span>
            {{dateCN(data.End)}} 
            周末留宿人数一览表
          </el-col>
          <el-col :span="8" v-if="tableData.length">
            <el-table border :data="tableData[0].Classes" size="medium">
              <el-table-column prop="Class" label="班级" align="center">
                <template slot-scope="{row}">
                  <span v-if="row.ToReview" style="color:#f11;">{{row.Class}}</span>
                  <span v-else>{{row.Class}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="Count" label="人数" align="center"/>
            </el-table>
          </el-col>
          <el-col :span="8" v-if="tableData.length">
            <el-table border :data="tableData[1].Classes" size="medium">
              <el-table-column prop="Class" label="班级" align="center">
                <template slot-scope="{row}">
                  <span v-if="row.ToReview" style="color:#f11;">{{row.Class}}</span>
                  <span v-else>{{row.Class}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="Count" label="人数" align="center"/>
            </el-table>
          </el-col>
          <el-col :span="8" v-if="tableData.length">
            <el-table border :data="tableData[2].Classes" size="medium">
              <el-table-column prop="Class" label="班级" align="center">
                <template slot-scope="{row}">
                  <span v-if="row.ToReview" style="color:#f11;">{{row.Class}}</span>
                  <span v-else>{{row.Class}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="Count" label="人数" align="center"/>
            </el-table>
          </el-col>
          <el-col :span="24" v-if="tableData.length">
            <el-table :data="[{}]" border :show-header="false" size="medium">
              <el-table-column align="center">
                <template>全校合计</template>
              </el-table-column>
              <el-table-column align="center">
                <template>
                  {{mainTotal}}
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="24" v-else>
            <div class="isNull">暂无数据</div>
          </el-col>
          <el-col :span="24" class="tip">
            <div>备注：只统计审核通过的学生</div>
            <div style="text-indent:2.65rem;">如果统计时间范围内班级有学生报名状态为未审核，则班级字体为红色。</div>
          </el-col>
        </el-row>
      </template>
      <template #footer>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      api: require("@/api/attendance/reg").default,
      data: {
        mainTotal: 0,
        Start: "",
        End: "",
      },
      searchDate: "",
      tableData: [],
      isMB: this.$store.state.isMB,
      rules: {
        
      },
    };
  },
  methods: {
    onDetailsOpened() {
      var date = new Date();
      var day = date.getDay();
      var set = "";
      if(day == 6) {
        set = this.$commonJs.getToday();
      } else if(day > 6) {
        var time = date.getTime() - 86400000;
        set = this.$commonJs.toDateString(new Date(time));
      } else {
        var time = date.getTime() + (86400000 * (6 - day));
        set = this.$commonJs.toDateString(new Date(time));
      }
      this.searchDate = set;
      this.getData();
    },
    getData() {
      this.loading(true);
      this.api.getStayRegStat({ Date: this.searchDate }).then(res => {
        this.loading(false);
        this.tableData = [];
        if(res.Code==0) {
          this.mainTotal = res.Data.Count;
          var td = res.Data.Grades;
          td.forEach(e => {
            if(e.Classes.length) {
              e.Classes.push({ Class: "小计", Count: e.Count })
            }
          })
          this.data.Start = res.Data.StartDate;
          this.data.End = res.Data.EndDate;
          this.tableData = td;
        } else {
          //--------------------------
          // this.mainTotal = 43;
          // var td = [
          //   { Count: 10, Grade: "高一", 
          //     Classes: [
          //       { Class: "1班", ToReview: false, Count: 4 },
          //       { Class: "2班", ToReview: true, Count: 6 },
          //     ] 
          //   },
          //   { Count: 20, Grade: "高二", 
          //     Classes: [
          //       { Class: "3班", ToReview: false, Count: 12 },
          //       { Class: "4班", ToReview: true, Count: 8 },
          //     ] 
          //   },
          //   { Count: 13, Grade: "高三", 
          //     Classes: [
          //       { Class: "5班", ToReview: false, Count: 5 },
          //       { Class: "6班", ToReview: true, Count: 8 },
          //     ] 
          //   },
          // ];
          // td.forEach(e => {
          //   if(e.Classes.length) {
          //     e.Classes.push({ Class: "小计", Count: e.Count })
          //   }
          // })
          // this.data.Start = "2022-01-01 00:00:00";
          // this.data.End = "2022-01-07 00:00:00";
          // this.tableData = td;
          //--------------------------
          this.$message.error(res.Msg);
        }
      })
    },
    dateCN(v) {
      if(!v) return "";
      var p = this.$commonJs.toDateString(v);
      var arr = p.split("/");
      return arr[0] + "年" + arr[1] + "月" + arr[2] + "日";
    },
    onClosed() {
      this.tableData = [];
      this.mainTotal = 0;
    },
  },
};
</script>
<style lang="scss" scoped>
.title {
  text-align: center;
  font-size: 16px;
  margin-bottom: 10px;
}
.isNull {
  text-align: center;
  font-size: 16px;
  letter-spacing: 5px;
  padding: 2rem 1rem;
  color: #999;
  border: 1px solid #eee;
}
.tip {
  margin-top: 10px;
  div{
    line-height: 22px;
  }
}
</style>